import React, { useState } from 'react'
import SuggestionButton from './suggestion-button/suggestion-button'
import SuggestionModal from './suggestion-modal/suggestion-modal'
import { LoadNewTicketSuggestion } from '@/javascript/domain/usecases'

type Props = {
  loadNewTicketSuggestion: LoadNewTicketSuggestion
  contracted: boolean
}

const AiTicketSuggestion: React.FC<Props> = ({ loadNewTicketSuggestion, contracted }) => {
  const [aiModalOpen, setAiModalOpen] = useState(false)
  return (
    <>
      <SuggestionButton onClick={() => setAiModalOpen(true)} contracted={contracted} />
      <SuggestionModal
        open={aiModalOpen}
        setOpen={setAiModalOpen}
        loadNewTicketSuggestion={loadNewTicketSuggestion}
      />
    </>
  )
}

export default AiTicketSuggestion
